import { COLORS } from 'helpers/globals'

export default {
  loading: {
    flex: 1,
    background: COLORS.secondary,
    fontSize: '2rem',
    textAlign: 'center',
    color: 'white',
    fontWeight: '400',
    display: 'flex',
    flexDirection: 'column',
    padding: '1rem'
  },
  loadingButton: {
    fontSize: '3rem',
    margin: 'auto'
  }
}



// WEBPACK FOOTER //
// ./src/components/BottomBar/style.js